var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-good-table',{ref:"vgt",attrs:{"styleClass":"vgt-table table table-stat vgt-table-odd-even","columns":_vm.filteredColumns,"rows":_vm.rows,"pagination-options":{
      enabled: _vm.rows.length > 25,
      perPage: 25,
      perPageDropdown: [25, 50, 100],
      rowsPerPageLabel: 'Строк на странице',
      allLabel: 'Все',
      ofLabel: 'из',
      prevLabel: 'Назад',
      nextLabel: 'Вперед',
    },"compactMode":""},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.tooltip)?_c('span',{staticClass:"column-tooltip",attrs:{"title":props.column.tooltip}},[_vm._v(_vm._s(props.column.label))]):_c('span',[_vm._v(_vm._s(props.column.label))])]}}])},[(_vm.exports)?_c('div',{attrs:{"slot":"table-actions"},slot:"table-actions"},[_c('button',{staticClass:"btn btn-blue",on:{"click":_vm.exportToCSV}},[_vm._v("Export CSV")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }